﻿import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/catch';

// APP 
import { Contact } from '../../viewmodel'
import { EntityAdded } from '../../viewmodel'
import { EntityParamForContact } from '../../viewmodel';
import { LookupService } from '../../services/lookup.service';
import { EntityService } from '../../services/entity.service';
import { SharedService } from '../../services/shared.service';

@Component({
    selector: 'app-addcontacts',
    templateUrl: './addcontacts.component.html',
    providers: [EntityService]
})
export class AddContactsComponent implements OnInit {
    title: string = 'Add Contacts';

    contactForm: FormGroup;
    public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    public extensionMask = [/\d/, /\d/, /\d/, /\d/] 
    public noSpaceAtBeginning = /^[^-\s]/;    

    pageError: any = [];
    pageSuccess: any = [];
    submitted: boolean = false;
    error: string;
    projectId: number = 0;
    entityId: number = 0;
    PartyRoleSeqNo: any;
    PartyRoleName: string;
    PartyId: any;
    PartyStagingId: any;
    selectedcompanyDdl = 0; 
    type: string;
    contact: any; 
    devTeamContact: any; 
    contacts: Array<any>;
    companies: Array<any>;
    hasCompany: boolean = false; 
    companyName: string; 
    entityAdded: any; 
    entityParamForContact: any; 
    newEntityEntry: string = '';
    isDdlDisable: boolean = true; 
    selectedCompanyIndexId: number = 0; 
    isCheckPrimDisable: boolean = false;
     attrDisabled: any = null;   //'disabled'  or null for enable

    constructor(private router: Router
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private lookupService: LookupService
        , private entityService: EntityService
        , private sharedService: SharedService) {

        this.contact = new Contact();
        this.entityAdded = new EntityAdded(); 
        this.entityParamForContact = new EntityParamForContact(); 
        this.contact.primaryContact = false;    
    }

    ngOnInit() {
        this.title = "Add Contact";

        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.contact.projectId = this.projectId = ids.projectId;
            }
        }
        if (this.projectId <= 0)
            this.sharedService.navigateHome();

        let eParam = this.sharedService.getJsonData('entityParam');
        if (eParam != null) {
            this.entityParamForContact = eParam as EntityParamForContact; 

            if (eParam.entityId != null)
                this.contact.entityId = this.entityId = eParam.entityId;
            if (eParam.contactId != null)
                this.contact.commContactId = eParam.contactId;
            if (eParam.newEntityEntry != null)
                this.newEntityEntry = eParam.newEntityEntry;
            if (eParam.partyId != null)
                this.PartyId = eParam.partyId;
            if (eParam.partyStagingId != null)
                this.PartyStagingId = eParam.partyStagingId;
            if (eParam.roleId != null)
                this.PartyRoleSeqNo = eParam.roleId;
            if (eParam.partyRoleName != null)
                this.PartyRoleName = eParam.partyRoleName;
            if (eParam.companyName != null)
                this.companyName = eParam.companyName;

       }     

        if (this.entityId <= 0)
            this.sharedService.navigateSummary();

        //get company list
        if (this.projectId > 0) {
            this.entityService.getActiveEntitiesAndCurrentPendingEntity(this.projectId, this.entityId,this.PartyId,this.PartyStagingId, this.PartyRoleSeqNo)
                .subscribe(
                successResp => {
                    if (!successResp.Success)
                        this.showError(successResp.StatusMessage);
                    else {
                        this.companies = successResp.Result;
 
                        if (this.companies != null && this.companies.length > 0)
                        {
                            this.companies.forEach((company) => {
                                if (company.RecordStatus.SeqNo == 3) {
                                    company.PartyRoleLookup.ShortName = this.PartyRoleName;
                                }
                            });
                            
                            this.hasCompany = true;                            
                            
                            this.getCompanyInfo(this.entityId); 
                            if (this.newEntityEntry != 'Y') {
                                this.isDdlDisable = false; 
                            }
                        }
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                });
        
        }  //end of company list      

        this.contactForm = this.frmBuilder.group({

            fName: [null, [Validators.required, Validators.pattern(this.noSpaceAtBeginning), Validators.maxLength(30)]],
            lName: [null, [Validators.required, Validators.pattern(this.noSpaceAtBeginning), Validators.maxLength(30)]],
            primary: [],
            email: [null, [Validators.required, Validators.maxLength(100), Validators.email]],
            companyPhone: [null, [Validators.required, Validators.pattern(/^\([1-9]\d{2}\)\s\d{3}-\d{4}|[1-9]\d{9}$/)]],
            phoneExt: [],
            companyDdl: [-1]

        });     
    }

    getCompanyInfo(entityId) {
        
        var found = false;      
        for (var i = 0; i < this.companies.length; i++) {
            if (entityId == this.companies[i].MIHProjectDevTeamID) {
               
                this.companyName = this.companies[i].PartyName;
                this.PartyRoleName = this.companies[i].PartyRoleLookup.ShortName; 
                this.selectCompany(i); 
                this.selectedCompanyIndexId = i; 
                if (this.companies[i].RecordStatus.SeqNo == 3)
                {
                    this.attrDisabled = 'disabled';
                    this.contact.primaryContact = true;
                }
                found = true; 
                break; 
            }
        }
        if (!found) {
            this.selectCompany(0);
            this.selectedCompanyIndexId = 0; 
        }
    }


    selectCompany(index) {

        if (index >= 0) {
            var partyId = this.companies[index].PartyID; 
            var partyStgId = this.companies[index].PartyStagingID;
            var TinVerifiedFlag = this.companies[index].TINVerfiedFlag; 
            this.contact.entityId = this.companies[index].MIHProjectDevTeamID;                 
            //this.entityAdded.IsStageEntry = partyId>0 ? false : true; 
            if (partyId > 0) {
                this.contact.partyId = this.companies[index].PartyID;
                this.contact.isStageEntry = false;
                this.entityAdded.IsStageEntry = false;  
                this.entityAdded.PartySeqNo = partyId;
                this.entityAdded.PartyAddressSeqNo = this.companies[index].PartyAddressID;
                 
            }
            else {
                this.contact.partyId = this.companies[index].PartyStagingID;
                this.contact.isStageEntry = true;
                this.entityAdded.IsStageEntry = true;
                this.entityAdded.PartySeqNo = partyStgId;
                this.entityAdded.PartyAddressSeqNo = this.companies[index].PartyAddressStagingID;
            }
            this.entityAdded.MIHProjectDevTeamID = this.entityId;
            this.getContacts(this.entityAdded);
        }        
    }

    selectContact(index) {
        if (index >= 0) {
            this.contact.commContactId = this.contacts[index].CommContactID;
            this.contact.fName = this.contacts[index].FirstName;
            this.contact.lName = this.contacts[index].LastName;
            this.contact.email = this.contacts[index].EmailAddress;
            if (this.contacts[index].ContactPhone != null && this.contacts[index].ContactPhone[0] != null) {
                this.contact.companyPhone = this.contacts[index].ContactPhone[0].PhoneNumber;
                this.contact.phoneExt = this.contacts[index].ContactPhone[0].PhoneExtension;
            }
            else {
                this.contact.companyPhone = ''; 
                this.contact.phoneExt = ''; 
                }
          
        }
        else {
            this.contact.commContactId = 0;
            this.contact.fName = '';
            this.contact.lName = '';
            this.contact.email = '';
            this.contact.companyPhone = '';
            this.contact.phoneExt = '';
        }
    }

    getContacts(entityAdded) {

        this.entityService.getContacts(entityAdded)
            .subscribe(
            successResp => {
                if (!successResp.Success)
                    this.showError(successResp.StatusMessage);
                else if (successResp.Result != null) {
                    if (successResp.Result.ContactDetails != null && successResp.Result.ContactDetails.length > 0) {
                        
                        this.contacts = successResp.Result.ContactDetails;
                        this.contact.partyid = successResp.Result.PartySeqNo;  // assign party id & isStageEntry
                        this.contact.isStageEntry = successResp.Result.isStageEntry;
                                       
                    }
                    else {
                        this.contacts = []; 
                    }
                }
            },
            error => {
                this.showError(error.ExceptionMessage)
            })
    }
    
    saveContact(btnType): any {
        this.submitted = true; 
        let cont = this.contactForm.getRawValue();
        if (!this.contactForm.valid)
            return;

        if (this.contact.fName != null && this.contact.fName.trim() == '') 
            this.contact.fName = '';
        if (this.contact.lName != null && this.contact.lName.trim() == '') 
            this.contact.lName = '';

        if (this.contact.fName == '' || this.contact.lName == '')
            return; 
           
        this.contact.fName = this.contact.fName.trim();
        this.contact.lName = this.contact.lName.trim();       
        this.contact.projectId = this.projectId;
        this.contact.dbApplicationId = 84;
        
        this.contact.isStageEntry = this.entityAdded.IsStageEntry;
        if (this.contact.phoneExt != null && this.contact.phoneExt != '') {
            this.contact.phoneExt = this.contact.phoneExt.replace(/_+/g, '');
        }

        // Remove masking
        if (this.contact.companyPhone) {
            this.contact.companyPhone = this.contact.companyPhone.replace(/\D/g, '');
        }

        this.entityService.saveNewEntityContact(this.contact, this.entityParamForContact)        
            .subscribe(
            success => {
                if (!success.Success) {
                    
                    if (success.StatusMessage != null && success.StatusMessage.indexOf('Contact already exists') !== -1) {
                        this.showErrorAlert(success.StatusMessage);
                    }
                    else if (success.StatusMessage != null && success.StatusMessage.indexOf('entity has already been added') !== -1) {
                        this.showErrorAlert(success.StatusMessage);
                    }
                    else {
                        this.showError(success.StatusMessage);
                    }
				}
                else {                    
                    this.showSuccess('Development contact successfully added.'); 
					
                    if (btnType == 'NEXT') { 
                        this.sharedService.navigateSummary();                                            
                    }
                    else if (btnType == 'ANOTHER') {
                        this.resetForm(); 
                    }
                }
            },
            error => {                
                this.showError(error.ExceptionMessage);
                
            })
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }


    home() {
        this.sharedService.navigateHome();
    }

    back() {
        this.sharedService.navigateSummary();
    }

    resetForm() { 
        // this.contact = [];
        this.entityAdded = new EntityAdded();
        this.contact = new Contact();
        this.contact.projectId = this.projectId;
        this.contact.entityId = this.entityId;
        this.contact.dbApplicationId = 84; 
        this.selectCompany(0); 
        this.selectedcompanyDdl = 0; 
        this.submitted = false;
        this.isDdlDisable = false; 
    }

    previous(btnType) {
        this.router.navigate(['/createentity']);
    }

    formatContact(contact) {
        var ret = '';

        if (!(contact.FirstName == null || contact.FirstName == ''))
            ret += contact.FirstName + ' '; 
        if (!(contact.LastName == null || contact.LastName == ''))
            ret += contact.LastName;

        if (!(contact.EmailAddress == null || contact.EmailAddress == ''))
            ret += " Email: " + contact.EmailAddress; 

        if (contact.ContactPhone != null && contact.ContactPhone.length > 0) {
            var comm = contact.ContactPhone[0]; 
            if (!(comm.PhoneNumber == null || comm.PhoneNumber == ''))
                ret += " Ph: " + this.formatPhone(comm.PhoneNumber );

             if (!(comm.PhoneExtension == null || comm.PhoneExtension == ''))
                ret += " Ext: " + comm.PhoneExtension; 
        }
        return ret;
    }

    formatPhone(value) {
        if (value == null || value.length == 0)
            return "";

        let newPhone = '';
        switch (value.length) {
            case 10:
            case 9:
            case 8:
            case 7:
                newPhone = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
                break;
            case 6:
            case 5:
            case 4:
                newPhone = value.slice(0, 3) + '-' + value.slice(3, 6);
                break;
            default:
                newPhone = value;
                break;
        }
        return newPhone;
    }
}